import { render, staticRenderFns } from "./M2hChallengesDetail.vue?vue&type=template&id=8ad60cc4&scoped=true&"
import script from "./M2hChallengesDetail.vue?vue&type=script&lang=js&"
export * from "./M2hChallengesDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad60cc4",
  null
  
)

export default component.exports